import banner from "./banner.webp"
import logo from "./logo.jpeg"

const shop = {
    id: "shop009",
  
    vendorId: "L03xKFwNYzbNSNZrGtG3YeHy01e2",
  
    slug: "burger-king-lagos",
  
    name: "Burger King",
  
    category: "food",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "large",

    products: [],

    location: "Lagos",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;